import React, { useState, useEffect } from "react";
import { DndContext, DragOverlay, rectIntersection } from "@dnd-kit/core";
import KanbanLane from "./KanbanLane";
import KanbanCard from "./KanbanCard";
import Modal from "../../../src/components/controls/modal/Modal";
import service from "../../store/services/user.service";
import styles from "./Kanban.module.scss";
import scopeService from "../../store/services/scope.service";
import {
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  useSensor,
  PointerSensor,
  useSensors,
} from "@dnd-kit/core";

export default function KanbanBoard(props) {
  const {
    scopeID,
    tasksList,
    data,
    createTaskRequest,
    updateTaskRequest,
    updateTaskStatusRequest,
    deleteTaskRequest,
    isCreate,
    setIsCreate,
    loading,
    modalLoading,
    error,
    body,
    setEdit,
    setSelectedRow,
    saveHandler,
    isButtonLoading,
    heightDelta,
    handleAction,
  } = props;
  const [onHoldItems, setonHoldItems] = useState([]);
  const [inProgressItems, setInProgressItems] = useState([]);
  const [monitoringItems, setMonitoringItems] = useState([]);
  const [slippingItems, setSlippingItems] = useState([]);
  const [completedItems, setCompletedItems] = useState([]);

  const [allTasks, setAllTasks] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [showManagerDropdown, setShowManagerDropdown] = useState(false);
  const [resources, setResources] = useState([]);
  const [resourceOptions, setResourceOptions] = useState([]);
  const [assignedResources, setAssignedResources] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [status, setStatus] = useState("");
  const [priority, setPriority] = useState("");
  const [budget, setBudget] = useState("");
  const [phase, setPhase] = useState("");
  const [scopes, setScopes] = useState([]);
  const [scope, setScope] = useState("");
  const [refId, setRefId] = useState("");
  const [description, setDescription] = useState("");
  const [isDraft, setIsDraft] = useState(false);
  const [isCritical, setIsCritical] = useState(false);
  const [isMilestone, setIsMilestone] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [activeCard, setActiveCard] = useState(null);
  const [collapsedLanes, setCollapsedLanes] = useState({});
  const [formErrors, setFormErrors] = useState({
    name: "",
  });
  const mouseSensor = useSensor(MouseSensor, {
    activationConstraint: { distance: 5 },
  });
  const touchSensor = useSensor(TouchSensor, {
    activationConstraint: { distance: 5 },
  });
  const keyboardSensor = useSensor(KeyboardSensor, {
    activationConstraint: { distance: 5 },
  });
  const pointerSensor = useSensor(PointerSensor, {
    activationConstraint: { distance: 5 },
  });
  const sensors = useSensors(
    mouseSensor,
    touchSensor,
    keyboardSensor,
    pointerSensor
  );

  useEffect(() => {
    if (error !== "") {
      Object.keys(error).forEach((key) => {
        if (key === "Name") {
          setFormErrors((prevErrors) => ({
            ...prevErrors,
            name: error[key][0],
          }));
        }
      });
    }
  }, [error]);

  useEffect(() => {
    setAllTasks(data);
  }, [data]);

  useEffect(() => {
    if (allTasks) {
      const inProgressTasks = allTasks.filter((task) => task.status === 0);
      setInProgressItems(inProgressTasks);
      const monitoringTasks = allTasks.filter((task) => task.status === 1);
      setMonitoringItems(monitoringTasks);
      const slippingTasks = allTasks.filter((task) => task.status === 2);
      setSlippingItems(slippingTasks);
      const completedTasks = allTasks.filter((task) => task.status === 3);
      setCompletedItems(completedTasks);
      const onHoldTasks = allTasks.filter((task) => task.status === 4);
      setonHoldItems(onHoldTasks);
    }
  }, [allTasks]);

  const getRequestPriority = (type) => {
    switch (type) {
      case 0:
        return "Low";
      case 1:
        return "Moderate";
      case 2:
        return "High";
      default:
        return "";
    }
  };

  const setRequestPriority = (type) => {
    switch (type) {
      case "Low":
        return 0;
      case "Moderate":
        return 1;
      case "High":
        return 2;
      default:
        return 0;
    }
  };

  const getStatus = (status) => {
    switch (status) {
      case "In Progress":
        return 0;
      case "Monitoring":
        return 1;
      case "Slipping":
        return 2;
      case "Completed":
        return 3;
      case "On Hold":
        return 4;
      default:
        return 0;
    }
  };

  const handleDragStart = (e) => {
    setActiveCard(e.active.data.current);
  };

  const handleDragEnd = (e) => {
    setActiveCard(null);
    const container = e.over?.id;
    if (!e.over?.id) {
      return;
    }
    if (e.active.id.status !== container) {
      const payload = {
        status: getStatus(container)
      };

      updateTaskStatusRequest({ parent: "Scope", id: scopeID, tId: e.active.id.id, payload });
    }
  };

  const handleDragCancel = () => {
    setActiveCard(null);
  };

  const handleSave = () => {
    saveHandler();

  };

  const setRequestStatus = (type) => {
    switch (type) {
      case "In Progress":
        return 0;
      case "Monitoring":
        return 1;
      case "Slipping":
        return 2;
      case "Completed":
        return 3;
      case "On Hold":
        return 4;
      default:
        return 0;
    }
  };

  const handleMove = (status) => {
    const updatedTask = selectedItem;
    updatedTask.status = setRequestStatus(status);
    const payload = {
      status: updatedTask.status
    };

   
    updateTaskStatusRequest({ 
      parent: "Scope",
      id: updatedTask.scopes[0].id,
      tId: updatedTask.id, 
      payload 
    });
  };

  const toggleLaneCollapse = (laneTitle) => {
    setCollapsedLanes(prev => ({
      ...prev,
      [laneTitle]: !prev[laneTitle]
    }));
  };

  useEffect(() => {
    if (isCreate) {
      setFormErrors({});
      setName("");
      setStartDate("");
      setEndDate("");
      setStatus("");
      setBudget("");
      setPhase("");
      setRefId("");
      setAssignedResources([]);
      setDescription("");
      setIsCritical(false);
      setIsMilestone(false);
      setIsDraft(false);
      setResources([]);
      setShowManagerDropdown(false);
      setResourceOptions([]);
      setPriority("");
      setShowModal(true);
      setModalTitle(`Create Task`);
      setSelectedItem({});
    }
  }, [isCreate]);

  const handeCancel = () => {
    setShowModal(false);
    setIsCreate(false);
    setShowDeleteModal(false);
  };

  const handleDelete = () => {
    deleteTaskRequest({ parent: "Scope", id: scopeID, tId: selectedItem.id });
  };
  useEffect(() => {
    if (!loading) {
      setShowModal(false);
      setShowDeleteModal(false);
      setIsCreate(false);
    }
  }, [loading, modalLoading]);

  useEffect(() => {
    if (!modalLoading) {
      setShowModal(false);
      setShowDeleteModal(false);
      setIsCreate(false);
    }
  }, [modalLoading]);

  const fetchTaskData = async () => {
    scopeService.getTaskDetails({ id: selectedItem.id }).then((taskData) => {
      setName(taskData.name);
      if (taskData.users) {
        const newArray = taskData.users.map((obj) => ({
          value: obj.id,
          label: obj.name,
          image: obj.image,
        }));
        setAssignedResources(newArray);
      } else {
        setAssignedResources([]);
      }
      setStartDate(taskData.startDate);
      setEndDate(taskData.endDate);
      setPriority(getRequestPriority(taskData.priority));
      setBudget(taskData.budget);
      setPhase(taskData.phase);
      setStatus(taskData.status);
      setRefId(taskData.refId);
      setDescription(taskData.description);
      setIsCritical(taskData.isCritical);
      setIsMilestone(taskData.isMilestone);
      setIsDraft(taskData.isDraft);
      // setScopes([])
    });
  };

  useEffect(() => {
    if (selectedItem) {
      setSelectedRow(selectedItem);
      setEdit(isEdit);
      // isEdit && fetchTaskData();
    } else {
      setName("");
      setStartDate("");
      setEndDate("");
      setStatus("");
      setBudget("");
      setPhase("");
      setRefId("");
      setAssignedResources([]);
      setDescription("");
      setResources([]);
      setShowManagerDropdown(false);
    }
  }, [isEdit, selectedItem]);

  return (
    <>
      <DndContext
        collisionDetection={rectIntersection}
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        onDragCancel={handleDragCancel}
        sensors={sensors}
      >
        <div 
          className={styles.KanbanContainer}
          style={{height : `calc(100vh - ${heightDelta})`}}
          >
          <div className={`row gx-2 h-100 ${styles.KanbanLanesContainer}`}>
            <div className={`col ${styles.KanbanLane} ${collapsedLanes["On Hold"] ? styles.KanbanLaneCollapsed : ''}`}>
              <KanbanLane
                title="On Hold"
                setShowModal={setShowModal}
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
                setIsEdit={setIsEdit}
                setModalTitle={setModalTitle}
                setShowDeleteModal={setShowDeleteModal}
                items={onHoldItems}
                handleMove={handleMove}
                heightDelta={heightDelta}
                handleAction={handleAction}
                isCollapsed={collapsedLanes["On Hold"]}
                onToggleCollapse={toggleLaneCollapse}
              />
            </div>
            <div className={`col ${styles.KanbanLane} ${collapsedLanes["In Progress"] ? styles.KanbanLaneCollapsed : ''}`}>
              <KanbanLane
                title="In Progress"
                setShowModal={setShowModal}
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
                setIsEdit={setIsEdit}
                setModalTitle={setModalTitle}
                setShowDeleteModal={setShowDeleteModal}
                items={inProgressItems}
                handleMove={handleMove}
                heightDelta={heightDelta}
                handleAction={handleAction}
                isCollapsed={collapsedLanes["In Progress"]}
                onToggleCollapse={toggleLaneCollapse}
              />
            </div>
            <div className={`col ${styles.KanbanLane} ${collapsedLanes["Monitoring"] ? styles.KanbanLaneCollapsed : ''}`}>
              <KanbanLane
                title="Monitoring"
                setShowModal={setShowModal}
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
                setIsEdit={setIsEdit}
                setModalTitle={setModalTitle}
                setShowDeleteModal={setShowDeleteModal}
                items={monitoringItems}
                handleMove={handleMove}
                heightDelta={heightDelta}
                handleAction={handleAction}
                isCollapsed={collapsedLanes["Monitoring"]}
                onToggleCollapse={toggleLaneCollapse}
              />
            </div>
            <div className={`col ${styles.KanbanLane} ${collapsedLanes["Slipping"] ? styles.KanbanLaneCollapsed : ''}`}>
              <KanbanLane
                title="Slipping"
                setShowModal={setShowModal}
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
                setIsEdit={setIsEdit}
                setModalTitle={setModalTitle}
                setShowDeleteModal={setShowDeleteModal}
                items={slippingItems}
                handleMove={handleMove}
                heightDelta={heightDelta}
                handleAction={handleAction}
                isCollapsed={collapsedLanes["Slipping"]}
                onToggleCollapse={toggleLaneCollapse}
              />
            </div>
            <div className={`col ${styles.KanbanLane} ${collapsedLanes["Completed"] ? styles.KanbanLaneCollapsed : ''}`}>
              <KanbanLane
                title="Completed"
                setShowModal={setShowModal}
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
                setIsEdit={setIsEdit}
                setModalTitle={setModalTitle}
                setShowDeleteModal={setShowDeleteModal}
                items={completedItems}
                handleMove={handleMove}
                heightDelta={heightDelta}
                handleAction={handleAction}
                isCollapsed={collapsedLanes["Completed"]}
                onToggleCollapse={toggleLaneCollapse}
              />
            </div>
          </div>
        </div>
        <DragOverlay dropAnimation={null}>
          {activeCard ? (
            <KanbanCard
              title={activeCard.title}
              details={activeCard.cardDetails}
              index={activeCard.index}
              parent={activeCard.parent}
              isOverlay
            />
          ) : null}
        </DragOverlay>
      </DndContext>

      {showModal ? (
        <Modal
          title={modalTitle}
          handleCancel={() => handeCancel()}
          handleSave={() => handleSave()}
          saveBtnLabel="Save"
          cancelBtnLabel="Cancel"
          isLoading={isButtonLoading}
          body={body}
          size="large"
        />
      ) : (
        <></>
      )}
      {showDeleteModal && (
        <Modal
          title={`Delete Task`}
          body={
            <p className="text-sm-400 subHeading-color">{`Are you sure you want to delete the selected task?`}</p>
          }
          handleCancel={() => handeCancel()}
          handleSave={() => handleDelete()}
          saveBtnLabel={`Delete`}
          cancelBtnLabel={"Cancel"}
          isLoading={false}
        />
      )}
    </>
  );
}
